import { useStripeContext } from "@/context/StripeContextProvider";
import { useEffect, useRef, useState } from "react";
import { track } from "@/utils/mixpanel";

export const QuizStripeEnricher = () => {
    const singleton = useRef(null);
    const { stripeData, setStripeData } = useStripeContext();

    useEffect(() => {
        if (singleton.current !== null || !stripeData) {
            return;
        }

        singleton.current = true;

        // const currentUrl = new URL(window.location.href);
        // const enableCustomPaymentMethods = currentUrl.searchParams.get("enableCustomPaymentMethods");
        const url = new URL("/quiz/stripe/subscription-create", window.location.origin);
        stripeData.couponId && url.searchParams.set("couponId", stripeData.couponId);
        // enableCustomPaymentMethods && url.searchParams.set("enableCustomPaymentMethods", enableCustomPaymentMethods);
        // url.searchParams.set("enableCustomPaymentMethods", "true");

        console.log("QuizStripeEnricher", { url: url.toString() });

        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(res => res.json())
            .then((data) => {
                setStripeData({
                    ...data,
                    customerId: data.customer?.id,
                    monthlySubscriptionId: data.monthlySubscription?.id,
                    annualSubscriptionId: data.annualSubscription?.id,
                });
                track("stripe_subscription_create_success");
            })
            .catch((err) => {
                console.error(err);
                track("stripe_subscription_create_error", {
                    error: err.message,
                });
            });
    }, [setStripeData, stripeData]);

    return null;
};
